/**
 * Asynchronously loads the component for Login
 */

import { lazyLoad } from "utils/loadable";

export const SetPassword = lazyLoad(
  () => import("./index"),
  (module) => module.SetPassword
);
